import React, { useState } from 'react'
import ModalVideo from "react-modal-video";
import "react-modal-video/css/modal-video.css";

function AboutArea(props) {
  const [isOpen, setOpen]=useState(false)
  return (
    <>
      <section className="about-area sec-mar-bottom">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 or-2 wow animate fadeIn" data-wow-delay="200ms" data-wow-duration="1500ms">
              <div className={`${"sec-title layout2"} ${props.white}`}>
                <span>Conózcanos un poco</span>
                <h2>Sobre Nosotros - Gekkonect</h2>
              </div>
              <div className={`${"about-left"} ${props.layoutClass}`}>
                <h3>Diseño, desarrollo y lanzamiento de software personalizado e Inteligencia Artificial.</h3>
                <p>
                  Somos un equipo apasionado por transformar desafíos en soluciones tecnológicas innovadoras. 
                  Con un enfoque en la excelencia y el detalle, nos dedicamos a desarrollar 
                  <strong> software personalizado que no solo cumple, sino que supera las expectativas</strong> 
                  de rendimiento y calidad. 
                  <strong> Expertos en plataformas de aprendizaje continuo e Inteligencia Artificial.</strong> 
                  Cada proyecto es una oportunidad para crear algo único, optimizando sistemas y garantizando 
                  la satisfacción total del cliente, siempre con el compromiso de impulsar el éxito de nuestros clientes.
                </p>
                <div className={`${"company-since"} ${props.layoutClass}`}>
                  <strong>#1</strong>
                  <h4>Innovando en el desarrollo de software <span>desde 2011.</span></h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default AboutArea